import React, { useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Container, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import ProductsList from './products-list';
import { MDBPageItem, MDBPageNav } from 'mdbreact';

export const Products = (props) => {
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Adjust as needed
  const pagesAmount = 250; // Setting pages amount to 100

  const [announcementsError, setError] = useState();
  const [products, setData] = useState();
  const [productsLoading, setLoading] = useState(false);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    if (currentPage < pagesAmount) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const call = async (offset) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/${`/khareedari-products?filter[order]=createdAt DESC&filter[include][0][relation]=company&filter[include][1][relation]=khareedariCategory&filter[limit]=${itemsPerPage}&filter[offset]=${offset}`}`
      );
      const result = await response.json();
      if (response.ok) {
        setData(result);
      } else {
        setError(result);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage === 1) {
      call(currentPage - 1);
    } else {
      call((currentPage - 1) * 10);
    }
  }, [currentPage]);

  //   const [products, , productsLoading] = useGet(
  //     '/khareedari-products?filter[order]=createdAt DESC&filter[include][0][relation]=company&filter[include][1][relation]=khareedariCategory',
  //     true
  //   );
  const handleEditProduct = useCallback(
    (obj) => {
      history.push(`/supplies/product-details/${obj.id}`);
    },
    [history]
  );

  // Create pagination range
  const pageNumbers = [];
  for (let i = 1; i <= pagesAmount; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    if (
      number === 1 ||
      number === pagesAmount ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      return (
        <MDBPageItem active={number === currentPage} key={number}>
          <MDBPageNav onClick={() => handlePageClick(number)} className="page-link-custom">
            {number}
          </MDBPageNav>
        </MDBPageItem>
      );
    } else if (number === currentPage - 2 || number === currentPage + 2) {
      return (
        <MDBPageItem key={number}>
          <MDBPageNav className="page-link-custom">...</MDBPageNav>
        </MDBPageItem>
      );
    }
    return null;
  });

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="align-items-end d-flex justify-content-between mb-3">
            <h4>Products</h4>
            <Link to="/supplies/add-product">
              <Button
                color="primary"
                outline
                type="button"
                size="sm"
                className="waves-effect waves-light"
              >
                Add New Product
                <i className="mdi mdi-plus align-middle ml-2"></i>
              </Button>
            </Link>
          </div>
          <Card>
            <CardBody>
              {productsLoading ? (
                <div className="text-center">
                  <Spinner className="mr-2" color="primary" />
                </div>
              ) : (
                <ProductsList
                  products={products}
                  editProduct={handleEditProduct}
                  currentPage={currentPage}
                  handlePrev={handlePrev}
                  renderPageNumbers={renderPageNumbers}
                  pagesAmount={pagesAmount}
                  handleNext={handleNext}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};
